import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
  })
  return function onClick() {
    change(next => {
      next.data = {
        ...next.data,
        actions: [],
      }
    })
  }
}
